import Vue from 'vue'
import VueRouter from 'vue-router'
import Default from '../layouts/Default.vue'
import Public from '../layouts/Public.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    component: Default,
    children: [
      {
        path: '/',
        name: 'Tableau de bord',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: '/welcome',
        name: 'Bienvenue',
        component: () => import('../views/Welcome.vue')
      },
      {
        path: '/messages',
        name: 'Messages',
        component: () => import('../views/Messages.vue')
      },
      {
        path: '/requests',
        name: 'Sourcing',
        component: () => import('../views/Requests.vue')
      },
      {
        path: '/welcome',
        name: 'Bienvenue',
        component: () => import('../views/Welcome.vue')
      },
      {
        path: '/packs',
        name: 'Les Forfaits',
        component: () => import('../views/Packs.vue')
      },
      {
        path: '/verification',
        name: 'Verification',
        component: () => import('../views/Verification.vue')
      },
      {
        path: '/orders',
        name: 'Commandes',
        component: () => import('../views/Orders.vue')
      },
      {
        path: '/stores',
        name: 'Boutiques',
        component: () => import('../views/Stores.vue')
      },
      {
        path: '/tickets',
        name: 'Tickets',
        component: () => import('../views/Tickets.vue')
      },
      {
        path: '/ticket/:id',
        name: 'Ticket',
        component: () => import('../views/Ticket.vue')
      },
      {
        path: '/calendar',
        name: 'Calendrier',
        component: () => import('../views/Calendar.vue')
      },
      {
        path: '/calendar2',
        name: 'Calendrier',
        component: () => import('../views/CalendarAffiliate.vue')
      },
      {
        path: '/account',
        name: 'Mon compte',
        component: () => import('../views/Account.vue')
      },
      {
        path: '/payments',
        name: 'Paiements',
        component: () => import('../views/Payments.vue')
      },
      {
        path: '/countries',
        name: 'Pays supportés',
        component: () => import('../views/Countries.vue')
      },
      {
        path: '/shopify',
        name: 'Shopify',
        component: () => import('../views/Shopify.vue')
      },
      {
        path: '/woocommerce',
        name: 'WooCommerce',
        component: () => import('../views/WooCommerce.vue')
      },
      {
        path: '/affiliate',
        name: 'Affiliate',
        component: () => import('../views/AffiliateDash.vue')
      },
    ]
  },
  {
    path:'/',
    name: 'public',
    component: Public,
    children: [
      {
        path: '/auth',
        name: 'auth',
        component: () => import('../views/Auth.vue')
      }
    ]
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
